// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__g_TkK","left":"StickyBox_left__1c5a4","right":"StickyBox_right__2YCa7"};